 
import { FC } from "react";
import { floatToPercent, floatToPrice } from "../../functions/price_functions";
import styles from './styles.module.css'
const CardPaymentDiscount: FC<{
  discountType: string,
  discountValue: string
}> = ({
  discountType,
  discountValue,
}) => {

  return (
     <div className={styles.discount}>
      {discountType === 'percentage' ? (
        <span>
          {parseFloat(discountValue) === parseInt(discountValue) ? (
        `${parseInt(discountValue)}% Off`
          ) : (
        `${floatToPercent(parseFloat(discountValue))} Off`
          )}
        </span>
      ) : (
        <span>
          {parseFloat(discountValue) === parseInt(discountValue) ? (
        `${floatToPrice(parseInt(discountValue))} Off`
          ) : (
        `${floatToPrice(parseFloat(discountValue))} Off`
          )} 
        </span>
      )}
        </div>
  )
}

export default CardPaymentDiscount;